import { useEffect } from "react";
import { Button, Card, Col, Form, Input, Row, Select, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { t } from "i18next";
import { useDataGrid } from "../../core/components/data-grid/DataGridContext";

export default function NotificationOutboxFilter() {
    const { onFilterPageSort, queryModel } = useDataGrid();
    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(queryModel.filter)
    }, [queryModel.updateKey])

    const onFinish = (formData) => {
        onFilterPageSort({ filter: formData })
    }

    return (
        <Card size="small" style={{ marginBottom: 16, backgroundColor: '#fdfdfd' }}>
            <Form form={form} size={'middle'} layout={'vertical'} onFinish={onFinish}>
                <Row gutter={[16, 16]} align="bottom">
                    <Col xs={24} sm={12} md={6}>
                        <Form.Item name={'eventType'} label={t('Notification Type')} style={{ marginBottom: 0 }}>
                            <Select allowClear placeholder={t('All')} options={[
                                { value: 'APPOINTMENT_CREATED', label: t('Randevu Oluşturma') },
                                { value: 'APPOINTMENT_REMINDER', label: t('Randevu Hatırlatma') },
                                { value: 'APPOINTMENT_RESCHEDULED', label: t('Randevu Zaman Değişikliği') },
                                { value: 'APPOINTMENT_COMPLETED', label: t('Randevu Tamamlandı') },
                                { value: 'APPOINTMENT_CANCELLED', label: t('Randevu İptal') },
                            ]} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={4}>
                        <Form.Item name={'channel'} label={t('Channel')} style={{ marginBottom: 0 }}>
                            <Select allowClear placeholder={t('All')} options={[
                                { value: 1, label: 'SMS' },
                                { value: 2, label: t('Email') },
                                { value: 4, label: t('WhatsApp') },
                            ]} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={4}>
                        <Form.Item name={'status'} label={t('Status')} style={{ marginBottom: 0 }}>
                            <Select allowClear placeholder={t('All')} options={[
                                { value: 0, label: t('Pending') },
                                { value: 1, label: t('Sent') },
                                { value: 2, label: t('Failed') },
                                { value: 3, label: t('Skipped') },
                            ]} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Form.Item name={'recipient'} label={t('Recipient')} style={{ marginBottom: 0 }}>
                            <Input placeholder={t('Recipient')} allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={4}>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Space>
                                <Button type="primary" htmlType={'submit'} icon={<SearchOutlined />}>{t('Search')}</Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    )
}
